export const team = [
  {
    name: 'John Doe',
    picture: 'https://i.pinimg.com/564x/59/7c/43/597c43c86327a7e9c642b2ae00d6a2ee.jpg'
  },
  {
    name: 'Alex Beyc',
    picture: 'https://i.pinimg.com/564x/9c/4c/e7/9c4ce74a69bdd3bf6d968c8893e7ca38.jpg'
  },
  {
    name: 'Trix Mach',
    picture: 'https://i.pinimg.com/564x/8f/39/eb/8f39eb89be4b84f9c9e3a73766837753.jpg'
  }
];
